import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FamilyMemberFormService } from 'src/app/_services/family-member-form.service';
import { ProposalService } from 'src/app/_services/proposal.service';
import { UserAuthService } from 'src/app/_services/user-auth.service';

import { BaseVehicleService } from './base-vehicle.service';
import { VEHICLE_STEPS, VEHICLE_STEPS_BASE } from './vehicle-constants';

@Injectable({
  providedIn: 'root',
})
export abstract class VehicleService extends BaseVehicleService {
  constructor(
    route: ActivatedRoute,
    authService: UserAuthService,
    proposalService: ProposalService,
    familyMemberService: FamilyMemberFormService,
    private router: Router,
  ) {
    super(route, authService, proposalService, familyMemberService);
    this.router.navigate([VEHICLE_STEPS_BASE, VEHICLE_STEPS.MAIN_FORM.url], {
      replaceUrl: true,
    });
    this.handleQueryParams();

    this.navigationChangeSubscription = this.router.events.subscribe((val) => {
      if (!(val instanceof NavigationEnd)) return;
      if (
        val.urlAfterRedirects.includes(VEHICLE_STEPS_BASE) &&
        val.urlAfterRedirects.includes(VEHICLE_STEPS.MAIN_FORM.url) &&
        !this.initDone
      )
        this.handleQueryParams();
    });
  }

  override resetForm() {
    super.resetForm();
    this.familyMemberService.reset();
  }
}
